import { render, staticRenderFns } from "./FloralVarietiesTable.vue?vue&type=template&id=1d35457e"
import script from "./FloralVarietiesTable.vue?vue&type=script&lang=js"
export * from "./FloralVarietiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports